<template>
  <div style="position: relative;">
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :pageOptions="pageOptions"
      :option="option"
      :page="page"
      :loading="loading"
      @onPageChange="onPageChange"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @downLoad="downLoad"
      @refresh-change="refreshChange"
      @submit-edit="submit"
    >
      <template slot="headLeftAera">
        <a-month-picker
          v-model="month"
          placeholder="Select month"
          format="YYYY-MM"
          :allow-clear="false"
        />
      </template>
      <template slot="headMenuLeft">
        <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            :disabled="downloading"
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownload"
          >
            <feather-icon icon="DownloadIcon" size="18" />
          </b-button>
        </my-tooltip>
      </template>
      <template slot="menuLeft" slot-scope="{ row }">
        <my-tooltip :tooltip="i18n('attendanceExamine.viewAttend')">
          <feather-icon
            icon="SearchIcon"
            size="20"
            class="cursor-pointer"
            @click="handleFormOpen('DirectorCheck', row)"
          />
        </my-tooltip>
      </template>
      <!-- slot-scope="{row}" -->
      <template slot="bottom">
        <b-button
          v-if="isChecked"
          type="submit"
          variant="primary"
          class="mr-3"
          style="float: right;margin-top: 10px"
          @click.prevent="validationForm"
        >
          {{ $t('_components.btns.confirm') }}
        </b-button>
      </template>
    </gtable-crud>
    <c-drawer v-model="drawerVisible" :before-close="handleBeforeClose">
      <component
        :is="formVisibleType"
        v-if="drawerVisible"
        :current-id="currentId"
        :month="currentMonth"
        :current-date="currentDate"
        :current-status="currentStatus"
        :default-form="searchQuery"
        @reLoad="reLoad"
        @closeForm="closeForm"
        @submit="submitCallBack"
      />
    </c-drawer>
    <c-modal
      :header="false"
      :footer="false"
      :visible="tipVisible"
      @close="tipVisible = false"
    >
      <template slot="content">
        <div class="audit-container">
          <span class="text-warning">
            <feather-icon icon="AlertCircleIcon" size="100" />
          </span>
          <h2 class="p-1">
            {{ $t('_worker.attendanceExamine.checkAttendanceTip') }}
          </h2>
          <!-- submit and cancel -->
          <div class="p-2">
            <b-button
              type="submit"
              variant="primary"
              class="mr-2"
              :disabled="auditLoading"
              @click.prevent="handleAuditConfirm"
            >
              {{ $t('_worker.attendanceExamine.check') }}
            </b-button>
            <b-button
              type="reset"
              variant="outline-secondary"
              :disabled="auditLoading"
              @click="tipVisible = false"
            >
              {{ $t('_components.btns.cancel') }}
            </b-button>
          </div>
        </div>
      </template>
    </c-modal>
  </div>
</template>

<script>
import { deepClone } from '@/util/util'
import { BButton } from 'bootstrap-vue'
import MyTooltip from '@/components/myTooltip.vue'
import CModal from '@/components/crud/modal.vue'
import CDrawer from '@/components/drawer.vue'
import {
  getList,
  downloadDirectorExam,
} from '@/api/worker/attendanceExamine/directorExamine'
import {
  getList as AttendanceList,
  sitedirectCheck,
} from '@/api/worker/attendance/attendance'
import DirectorCheckForm from './components/directorCheck.vue'
import { pageOptions } from '@/config/pageOption'
export default {
  components: {
    MyTooltip,
    DirectorCheckForm,
    CModal,
    CDrawer,
    BButton,
  },
  data() {
    return {
      query: {},
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 12,
      },
      pageOptions: [],
      currentId: '',
      data: [],
      loading: false,
      dialogShow: false,
      drawerTitle: '',
      drawerVisible: false,
      tipVisible: false,
      formVisibleType: '',
      detailVisible: true,
      mapModalShow: false,
      currentData: {},
      currentStatus: '',
      month: moment(new Date()).format('YYYY-MM'),
      downloading: false,
      // currentMonth: moment(new Date()).format('YYYY-MM'),
    }
  },
  computed: {
    isChecked() {
      if (!this.data.length) {
        return false
      }
      return this.data.every((el) => !el.sitedirectorStatus)
    },
    option() {
      const columns = [
        {
          label: this.i18n('label.employmentCode'),
          field: 'employmentCode',
          search: true,
          searchBase: true,
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendance.name'),
          field: 'name',
          search: true,
          searchBase: true,
          width: '150px',
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },

        {
          label: this.i18n('attendanceExamine.attendanceDate'),
          field: 'attendanceDate',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd',
          width: '130px',
          type: 'month',
          allowClear: false,
          formOption: {
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
            editHide: true,
          },
        },
        {
          label: this.i18n('label.specialistName'),
          dictField: 'specialistName',
        },
        {
          label: this.i18n('label.projectId'),
          field: 'projectId',
          type: 'select',
          dictField: 'projectName',
          dictCode: 'project',
          formOption: {
            editHide: true,
            type: 'select',
            dictCode: 'project',
          },
        },
        {
          label: 'Am Sum',
          field: 'amSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'Pm Sum',
          field: 'pmSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'Ot Hours Sum',
          field: 'otHoursSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'Bonus Sum',
          field: 'bonusSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.notAttendanceDays'),
          field: 'notAttendanceDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.injuryDays'),
          field: 'injuryDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.leaveDays'),
          field: 'leaveDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.attendanceDays'),
          field: 'attendanceDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.haveAttendanceDays'),
          field: 'haveAttendanceDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'status',
          // field: 'sitedirectorStatus',
          field: 'sitedirectorStatusName',
          formOption: {
            editHide: true,
          },
        },
      ]
      const option = {
        header: true, // 显示顶部功能区(默认 true)
        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)
        batchDelBtn: false, // 批量删除按钮(默认 false)
        upLoadBtn: true, // 上传按钮(默认 false)
        downLoadBtn: true, // 下载按钮(默认 false)
        search: true, // 显示搜索(默认 true)
        menu: true, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        selection: true, // 复选框(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)
        columns,
      }
      return option
    },
    currentMonth() {
      return moment(this.month).format('YYYY-MM')
    },
  },
  watch: {
    currentMonth() {
      this.onLoad(this.page)
    },
  },
  mounted() {
    this.pageOptions = pageOptions
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      // const currentDate = dateFormat(new Date(), 'yyyy-MM-dd')
      const res = await getList(page.currentPage, page.pageSize, {
        attendanceDate: this.currentMonth,
        ...Object.assign(params, this.query),
      })
      const { data } = res.data
      this.page.total = data.total
      this.data = data.records
      // this.data = data.records.map(el => {
      //   const obj = deepClone(el)
      //   obj.clockInStatus = String(obj.clockInStatus)
      //   obj.clockOutStatus = String(obj.clockOutStatus)
      //   obj.status = String(obj.status)
      //   return obj
      // })
      this.loading = false
    },
    handleDownload() {
      this.downloading = true
      downloadDirectorExam({
        ...this.query,
        attendanceDate: this.currentMonth,
      }).then((res) => {
        this.downloading = true
        this.getBlobObj(res.data, 'Attendence Sum.xlsx')
      })
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context])
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      this.query = { ...this.query, ...e }
      this.page.currentPage = 1
      await this.onLoad(this.page, e)
      done()
    },
    async refreshChange() {
      this.page.currentPage = 1
      await this.onLoad(this.page)
    },
    searchReset() {
      this.onLoad(this.page)
    },
    handleFormOpen(key, row) {
      if (row && row.workerId) {
        this.currentId = row.workerId
      }
      this.currentStatus = row.sitedirectorStatus
      if (row && row.attendanceDate) {
        this.currentDate = row.attendanceDate
      }
      this.form = deepClone(row)
      this.drawerVisible = true
      //   this.drawerTitle = this.$t(`_components.btns.${key}`)
      // ForemanCheck
      this.formVisibleType = `${key}Form`
    },
    handleBeforeClose() {
      this.drawerVisible = false
      this.onLoad(this.page)
    },
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
    },
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    closeForm() {
      this.drawerVisible = false
      this.onLoad(this.page)
    },
    reLoad() {
      this.onLoad(this.page)
    },
    validationForm() {
      this.tipVisible = true
    },
    handleAuditConfirm() {
      sitedirectCheck({ attendanceDate: this.currentMonth }).then((res) => {
        this.tipVisible = false
        this.onLoad(this.page)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.audit-container {
  text-align: center;
}
</style>
